// ThemeContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { getSecureItem, setSecureItem } from '../../services/SecureStorage';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [selectedOption, setSelectedOption] = useState(
        getSecureItem('selectedOption') || 'default'
    );

    const handleOptionClick = (name) => {
        setSelectedOption(name);
        setSecureItem('selectedOption', name);
    };

    function check_theme() {
        if (localStorage.theme === 'dark') {
            document.documentElement.setAttribute('data-theme', 'dark')
        } else {
            document.documentElement.setAttribute('data-theme', 'light')
        }
    }
    check_theme()
    const [darkmode, setDarkmode] = useState(
        getSecureItem('darkmodeState') === 'true'
    );
    function toggle_darkmode() {
        setDarkmode(prevState => !prevState);
        if (localStorage.theme === 'dark') {
            localStorage.theme = 'light'
        } else {
            localStorage.theme = 'dark'
        }
        check_theme()
    }
    useEffect(() => {
        setSecureItem('darkmodeState', darkmode);
    }, [darkmode]);

    const [isActive, setActive] = React.useState(window.innerWidth >= 1200);
    const sidebarToggle = () => {
        setActive(!isActive);
    }
    useEffect(() => {
        if (window.innerWidth < 1200) {
            document.body.classList[isActive ? "add" : "remove"]("overflow-hidden")
        }
    }, [isActive])

    const [miniSidebar, setMiniSidebar] = useState(
        getSecureItem('miniSidebarState') === 'true'
    );
    const toggle_miniSidebar = () => {
        setMiniSidebar(prevState => !prevState);
    }
    useEffect(() => {
        setSecureItem('miniSidebarState', miniSidebar);
    }, [miniSidebar]);

    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <ThemeContext.Provider value={{ selectedOption, handleOptionClick, toggle_darkmode, darkmode, isActive, setActive, sidebarToggle, toggle_miniSidebar, miniSidebar, isHovered, handleMouseEnter, handleMouseLeave }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    return useContext(ThemeContext);
};
